declare const I18n;

import React, { useState } from "react";
import TextInput from "@/components/inputs/TextInput";
import api from "../../../../api";

type Rank = {
  id: number;
  name: string;
  slug: string;
  points_required: number;
  level: number;
};

type OverallRankIndexProps = {
  overallRanks: Rank[];
};

const OverallRankIndex: React.FC<OverallRankIndexProps> = ({ overallRanks }) => {
  const [ranks, setRanks] = useState<Rank[]>(overallRanks);
  const [errors, setErrors] = useState<Record<number, string>>({});
  const [saving, setSaving] = useState(false);

  const updateRankPoints = (id: number, value: string) => {
    setRanks((prev) =>
      prev.map((rank) =>
        rank.id === id
          ? { ...rank, points_required: Number(value) }
          : rank
      )
    );

    setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);

    try {
      await api.updateOverallRanks({
        overall_ranks: ranks.map(({ id, points_required }) => ({
          id,
          points_required,
        })),
      });
    } catch (error: any) {
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      }
      console.error(error);
    } finally {
      setSaving(false);
      const url = new URL(window.location.href);
      url.searchParams.set("tab", "ranks");
      window.location.href = url.toString();
    }
  };

  return (
    <form className="skills-container" onSubmit={handleSubmit}>
      {ranks
        .sort((a, b) => a.level - b.level)
        .map((rank) => (
          <div key={rank.id} style={{ marginBottom: 40 }}>
            <h3 className="yellow">
              {I18n.t("models.overall_rank.messaging.level", {
                level: rank.level,
              })}
            </h3>

            <div className="row" style={{ maxWidth: "80%" }}>
              <div className="col-md-6">
                <TextInput
                  style={{ pointerEvents: "none" }}
                  columnSize={12}
                  value={rank.name}
                  error=""
                  type="overall_ranks"
                  field="name"
                  label={I18n.t(
                    "models.overall_rank.messaging.level_name"
                  )}
                  className="regular"
                  onChange={() => { }}
                />
              </div>

              <div className="col-md-6">
                <TextInput
                  columnSize={12}
                  value={String(rank.points_required)}
                  error={errors[rank.id] || ""}
                  type="overall_ranks"
                  field="points_required"
                  label={I18n.t(
                    "models.overall_rank.messaging.points_required"
                  )}
                  className="required"
                  onChange={(value) =>
                    updateRankPoints(rank.id, value)
                  }
                />
              </div>
            </div>
          </div>
        ))}

      <div className="form-group">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={saving}
        >
          {saving
            ? I18n.t("views.forms.submitting")
            : I18n.t("views.forms.save_changes")}
        </button>
      </div>
    </form>
  );
};

export default OverallRankIndex;
